// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Imprint from '../components/Imprint/Imprint';

@observer class ImprintRoute extends Component<any, any> {


	render() {
		return (
			<Imprint />
		)
	}
}

export default ImprintRoute;

